import { memo, SetStateAction, useEffect, useState } from 'react';
import { Slider } from 'antd';
import { PriceSliderProps, TMarks } from './PriceSlider.types';
import styles from './PriceSlider.module.scss';
import NormalPrice from '../NormalPrice';
import { ConfigProvider } from 'antd';

const PriceSlider = memo((props: PriceSliderProps) => {
  const { minPrice, maxPrice, step, priceVal } = props;
  const [marks, setMarks] = useState<TMarks>({});

  useEffect(() => {
    const tempMarks: SetStateAction<TMarks> = {};
    tempMarks[minPrice] = <NormalPrice fontSize={14} price={minPrice} />;
    tempMarks[maxPrice] = <NormalPrice fontSize={14} price={maxPrice} />;
    setMarks(tempMarks);
  }, []);

  return (
    <div className={styles.price_slider}>
      <div className={styles.price_title_wrapper}>
        <div className={styles.price_title}>投保額</div>
        <NormalPrice fontSize={16} price={priceVal || 0} />
      </div>
      <ConfigProvider
        theme={{
          components: {
            Slider: {
              // 滑块
              handleColor: '#E87722',
              handleLineWidth: 4,
              handleLineWidthHover: 4,
              handleSize: 16,
              handleSizeHover: 16,
              // 轨道
              railBg: '#B3B6B8',
              railHoverBg: '#B3B6B8',
              trackBg: '#E87722',
              trackHoverBg: '#E87722',
            },
          },
        }}
      >
        <Slider
          tooltip={{ open: false }}
          onChange={(val: any) => props.updateCurSumInsured(val)}
          onChangeComplete={props.onChange}
          value={priceVal}
          min={minPrice}
          max={maxPrice}
          marks={marks}
          step={step}
        />
      </ConfigProvider>
    </div>
  );
});
export default PriceSlider;
